import { render, staticRenderFns } from "./WordRecord.vue?vue&type=template&id=15756415&"
import script from "./WordRecord.vue?vue&type=script&lang=js&"
export * from "./WordRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports